<template>
  <div>
    <b-modal id="modal-edit" size="xl" centered :title="$store.state.modal.editKelengkapanPelamar" header-bg-variant="warning" header-text-variant="light">
      <b-tabs content-class="mt-3" align="center">
        <b-tab :title="$store.state.tab.profilPelamar">
          <edit-tab-profil :dataProfil="dataProfil" :data="data" :loker="loker" :edit2="edit2" @profilFromChild="fromProfil($event)" />
        </b-tab>
        <b-tab :title="$store.state.tab.riwayatPendidikan">
          <edit-tab-pendidikan :listRiwayat="listRiwayat" :edit2="edit2" @riwayatFromChild="fromRiwayat($event)" />
        </b-tab>
        <b-tab :title="$store.state.tab.pengalamanKerja">
          <edit-tab-kerja :listPengalaman="listPengalaman" :edit2="edit2" @pengalamanFromChild="fromPengalaman($event)" />
        </b-tab>
        <b-tab :title="$store.state.tab.lampiran">
          <edit-tab-lampiran :kebutuhanPelamar="kebutuhanPelamar" :data="data" />
        </b-tab>
        <!-- <b-tab :title="$store.state.tab.status">
          <edit-tab-status :data="data" @statusFromChild="fromStatus($event)" />
        </b-tab> -->
      </b-tabs>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')"> Batal </b-button>
        <b-button v-if="dataProfil != '' && dataRiwayat.length" :disabled="bussy" variant="primary" v-b-modal.modal-konfirmasi-input>
          {{ button }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-konfirmasi-input" size="md" centered :title="$store.state.modal.konfirmasiInputData" header-bg-variant="info" header-text-variant="light">
      <p>Apakah data Anda sudah sesuai?</p>

      <template #modal-footer>
        <b-button variant="secondary" @click="batal"> Batal </b-button>
        <b-button variant="primary" :disabled="bussy" @click="create">{{ button }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import editTabProfil from "./editTabProfil.vue";
import editTabPendidikan from "./editTabPendidikan.vue";
import editTabKerja from "./editTabKerja.vue";
import editTabLampiran from "./editTabLampiran.vue";
// import editTabStatus from "./editTabStatus.vue";
import moment from "moment";
moment.locale("id");
export default {
  name: "modalInput",
  props: ["data", "loker", "edit"],
  components: {
    editTabProfil,
    editTabPendidikan,
    editTabKerja,
    editTabLampiran,
    // editTabStatus,
  },

  data() {
    return {
      variant: "",
      msg: "",
      button: "Simpan",
      bussy: false,
      dataProfil: {},
      dataRiwayat: "",
      dataPengalaman: "",
      dataLampiran: "",
      dataStatus: "",
      listRiwayat: [],
      listPengalaman: [],
      penampung: [],
      kebutuhanPelamar: [],
      edit2: false,
    };
  },
  watch: {
    edit: function (newVal, oldVal) {
      if (oldVal != newVal) {
        let vm = this;
        vm.dataProfil = {};
        if (!vm.data.statusKelengkapan) {
          vm.listRiwayat = [];
          vm.listPengalaman = [];
          vm.dataRiwayat = [];
          vm.dataPengalaman = [];
          vm.kebutuhanPelamar = [];
          vm.getKebutuhan();
          vm.dataProfil.nomorKTPPelamar = vm.data.nomorKTPPengirim;
          vm.dataProfil.namaPelamar = vm.data.namaPengirim;
          vm.dataProfil.alamatPelamar = vm.data.alamatPengirim;
          vm.dataProfil.emailPelamar = vm.data.emailPengirim;
          vm.dataProfil.nomorTeleponPengirim = vm.data.nomorTeleponPengirim;
          vm.dataProfil.tanggalLahirPengirim = vm.data.tanggalLahirPengirim;
          if (vm.data.tanggalLahirPengirim) {
            vm.dataProfil.tglLahir = moment(vm.data.tanggalLahirPengirim).format("LL");
          }
          vm.dataProfil.tanggalMasukLamaran = moment(new Date()).startOf("day").format("YYYY-MM-DD");
          vm.dataProfil.tglMasuk = moment(vm.dataProfil.tanggalMasukLamaran).format("LL");
        } else {
          vm.getKebutuhan();
          vm.getDetail();
        }
      }
    },
  },
  methods: {
    fromProfil(data) {
      this.dataProfil = data;
    },
    fromRiwayat(data) {
      this.dataRiwayat = data.data;
    },
    fromPengalaman(data) {
      this.dataPengalaman = data.data;
    },
    fromLampiran(data) {
      this.dataLampiran = data;
    },
    fromStatus(data) {
      this.dataStatus = data;
    },
    async getKebutuhan() {
      let vm = this;
      let id = this.data.postLokerId;
      let listKebutuhan = await vm.$axios.get("postLoker/listKebutuhanByLokerId/" + id);

      vm.kebutuhanPelamar = listKebutuhan.data.data.map((item) => {
        return {
          ...item,
          file1: "",
        };
      });
    },
    getDetail() {
      let vm = this;
      let id = vm.data.postLokerId;
      // let status = vm.data.statusPostLoker;
      vm.dataProfil = {};
      vm.listRiwayat = [];
      vm.listPengalaman = [];
      vm.dataRiwayat = [];
      vm.dataPengalaman = [];
      vm.kebutuhanPelamar = [];
      vm.$axios
        .get("postLoker/detailListByStatus/" + id)
        .then((res) => {
          // console.log(res.data.data[0].riwayatPendidikan.length, "iki");
          vm.listRiwayat = res.data.data[0].riwayatPendidikan;
          vm.listPengalaman = res.data.data[0].pengalamanKerja;
          vm.dataRiwayat = res.data.data[0].riwayatPendidikan;
          vm.dataPengalaman = res.data.data[0].pengalamanKerja;
          vm.kebutuhanPelamar = res.data.data[0].kebutuhanPelamar;
          vm.dataProfil = res.data.data[0];
          if (this.data.tanggalLahirPengirim) {
            this.dataProfil.tglLahir = moment(this.data.tanggalLahirPengirim).format("LL");
          }
          vm.dataProfil.tglMasuk = moment(vm.dataProfil.tanggalMasukLamaran).format("LL");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    create() {
      let vm = this;
      let x = {
        namaPelamar: vm.dataProfil.namaPelamar,
        nomorKTPPelamar: vm.dataProfil.nomorKTPPelamar,
        posisiLamaran: vm.data.posisiDilamar,
        tinggiBadanPelamar: vm.dataProfil.tinggiBadanPelamar,
        beratBadanPelamar: vm.dataProfil.beratBadanPelamar,
        agamaPelamar: vm.dataProfil.agamaPelamar,
        kebangsaanPelamar: vm.dataProfil.kebangsaanPelamar,
        jenisKelaminPelamar: vm.dataProfil.jenisKelaminPelamar,
        statusPelamar: vm.dataProfil.statusPelamar,
        tempatLahirPelamar: vm.dataProfil.tempatLahirPelamar,
        tanggalLahirPelamar: vm.dataProfil.tanggalLahirPengirim,
        noHpPelamar: vm.dataProfil.nomorTeleponPengirim,
        emailPelamar: vm.dataProfil.emailPelamar,
        alamatPelamar: vm.dataProfil.alamatPelamar,
        tanggalMasukLamaran: vm.dataProfil.tanggalMasukLamaran,
        postLokerId: vm.data.postLokerId,
        statusKelengkapan: 1,
        bulkPengalamanKerja: vm.dataPengalaman,
        bulkRiwayatPendidikan: vm.dataRiwayat,
      };
      // console.log(x, "inix", this.dataProfil.tanggalLahirPengirim);
      if (vm.data.statusKelengkapan == null) {
        vm.$axios
          .post("kelengkapanLamaran/register", x)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.bussy = false;
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENGEDIT DATA KELENGKAPAN",
                showing: true,
              });
              vm.$bvModal.hide("modal-edit");
              vm.$bvModal.hide("modal-konfirmasi-input");
            } else {
              vm.bussy = false;
              vm.$bvModal.hide("modal-edit");
              vm.tabIndex = 0;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: _.toUpper(res.data.message),
                showing: true,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            vm.tabIndex = 0;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: "TERJADI KESALAHAN PADA SERVER",
              showing: true,
            });
          });
      } else {
        vm.$axios
          .post("kelengkapanLamaran/updateAll", {
            id: vm.data.kelengkapanLamaranId,
            namaPelamar: vm.dataProfil.namaPelamar,
            nomorKTPPelamar: vm.dataProfil.nomorKTPPelamar,
            posisiLamaran: vm.data.posisiDilamar,
            tinggiBadanPelamar: vm.dataProfil.tinggiBadanPelamar,
            beratBadanPelamar: vm.dataProfil.beratBadanPelamar,
            agamaPelamar: vm.dataProfil.agamaPelamar,
            kebangsaanPelamar: vm.dataProfil.kebangsaanPelamar,
            jenisKelaminPelamar: vm.dataProfil.jenisKelaminPelamar,
            statusPelamar: vm.dataProfil.statusPelamar,
            tempatLahirPelamar: vm.dataProfil.tempatLahirPelamar,
            tanggalLahirPelamar: vm.dataProfil.tanggalLahirPengirim,
            noHpPelamar: vm.dataProfil.noHpPelamar,
            emailPelamar: vm.dataProfil.emailPelamar,
            alamatPelamar: vm.dataProfil.alamatPelamar,
            tanggalMasukLamaran: vm.dataProfil.tanggalMasukLamaran,
            postLokerId: vm.data.postLokerId,
            statusKelengkapan: 1,
            bulkPengalamanKerja: vm.dataPengalaman,
            bulkRiwayatPendidikan: vm.dataRiwayat,
          })
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.bussy = false;
              vm.$bvModal.hide("modal-edit");
              vm.$bvModal.hide("modal-konfirmasi-input");
            } else {
              vm.bussy = false;
              vm.$bvModal.hide("modal-edit");
              vm.tabIndex = 0;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: _.toUpper(res.data.message),
                showing: true,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            vm.tabIndex = 0;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: "TERJADI KESALAHAN PADA SERVER",
              showing: true,
            });
          });
      }
    },
    batal() {
      this.$bvModal.hide("modal-konfirmasi-input");
    },
  },
};
</script>
